(function () {
  'use strict';

  // Fallback: imita el formato de la tienda ($ {{amount}} + money_without_trailing_zeros).
  // Agrupación en-US porque es-MX no agrupa números de 4 dígitos y Shopify sí imprime "1,275".
  function moneyFmt(cents) {
    var n = Math.round(Number(cents) || 0);
    var whole = Math.floor(n / 100), frac = n % 100;
    var out = '$ ' + whole.toLocaleString('en-US');
    if (frac) out += '.' + (frac < 10 ? '0' + frac : frac);
    return out;
  }

  function init(pdp) {
    if (!pdp || pdp.dataset.muxumPdpInit === '1') return;
    pdp.dataset.muxumPdpInit = '1';

    var form = pdp.querySelector('[data-muxum-pdp-form]');
    var format = pdp.querySelector('[data-muxum-format]');
    var qty = pdp.querySelector('[data-muxum-qty]');
    var qtyInput = pdp.querySelector('[data-muxum-qty-input]');
    var submit = pdp.querySelector('[data-muxum-pdp-submit]');
    var submitPrice = pdp.querySelector('[data-muxum-submit-price]');
    var submitLabel = pdp.querySelector('[data-muxum-submit-label]');
    var priceNow = pdp.querySelector('[data-muxum-price-now]');
    var priceWas = pdp.querySelector('[data-muxum-price-was]');
    var priceSave = pdp.querySelector('[data-muxum-price-save]');
    var mainImg = pdp.querySelector('[data-muxum-main-img]');

    /* La imagen principal se sirve con srcset/sizes (LCP). Si solo cambiamos
       .src, el navegador sigue eligiendo del srcset viejo y el swap no se ve:
       hay que quitar srcset y sizes antes. Guardamos la URL grande en
       dataset.fullSrc para que el lightbox abra en alta. */
    function setMainImage(src) {
      if (!mainImg || !src) return;
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = src;
      mainImg.dataset.fullSrc = src;
    }

    var subWrap = pdp.querySelector('[data-muxum-sub]');
    var subInputs = subWrap ? subWrap.querySelectorAll('[data-muxum-selling-plan]') : [];

    /* === Per-variant selling-plan prices: { variantId: { planId: formattedPrice } } === */
    var planPriceData = null;
    var planPricesEl = pdp.querySelector('[data-muxum-plan-prices]');
    if (planPricesEl) {
      try { planPriceData = JSON.parse(planPricesEl.textContent); } catch (e) { planPriceData = null; }
    }

    function updatePlanPrices(variantId) {
      if (!planPriceData) return;
      var vmap = planPriceData[variantId];
      if (!vmap) return;
      Object.keys(vmap).forEach(function (planId) {
        var el = pdp.querySelector('[data-muxum-plan-price="' + planId + '"]');
        if (el) el.textContent = vmap[planId];
      });
    }

    /* === Variant pills === */
    if (format) {
      var pills = format.querySelectorAll('.mx-format__pill');
      var pillInputs = format.querySelectorAll('input[type="radio"][data-muxum-variant-id]');

      pillInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          // Update active class
          pills.forEach(function (p) { p.classList.remove('is-active'); });
          var label = input.closest('.mx-format__pill');
          if (label) label.classList.add('is-active');

          // Update price
          var price = parseInt(input.dataset.variantPrice, 10);
          var compare = parseInt(input.dataset.variantCompare, 10);
          var available = input.dataset.variantAvailable === 'true';

          // Preferimos las cadenas del servidor (Liquid) para no re-formatear dinero en JS.
          if (priceNow && !isNaN(price)) priceNow.textContent = input.dataset.variantPriceFmt || moneyFmt(price);
          if (priceWas) {
            if (compare > price) {
              priceWas.textContent = input.dataset.variantCompareFmt || moneyFmt(compare);
              priceWas.style.display = '';
            } else {
              priceWas.style.display = 'none';
            }
          }
          if (priceSave) {
            if (compare > price) {
              priceSave.textContent = 'Ahorra ' + (input.dataset.variantSaveFmt || moneyFmt(compare - price));
              priceSave.style.display = '';
            } else {
              priceSave.style.display = 'none';
            }
          }

          // Update image
          setMainImage(input.dataset.variantImage);

          // Update subscription plan prices for the selected variant (before submit price reflects)
          updatePlanPrices(input.value);

          // Update submit button
          if (!available) {
            submit.disabled = true;
            if (submitLabel) submitLabel.textContent = 'Agotado';
          } else {
            submit.disabled = false;
            updateSubmitPrice();
          }

          // Update sub one-time price
          var onetimePrice = pdp.querySelector('[data-muxum-onetime-price]');
          if (onetimePrice && !isNaN(price)) {
            onetimePrice.textContent = input.dataset.variantPriceFmt || moneyFmt(price);
          }
        });
      });
    }

    /* === Subscription radio === */
    if (subInputs.length > 0) {
      subInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          var options = subWrap.querySelectorAll('.mx-sub__option');
          options.forEach(function (o) { o.classList.remove('is-active'); });
          var label = input.closest('.mx-sub__option');
          if (label) label.classList.add('is-active');
          updateSubmitPrice();
        });
      });
    }

    /* === Qty stepper === */
    if (qty) {
      qty.querySelectorAll('[data-muxum-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.dataset.muxumQtyStep, 10) || 1;
          var current = parseInt(qtyInput.value, 10) || 1;
          var next = Math.max(1, current + step);
          qtyInput.value = next;
        });
      });
    }

    /* === Submit price reflect === */
    function getCurrentPrice() {
      // If a selling plan is selected, use its price
      var selectedSubInput = subWrap ? subWrap.querySelector('input[data-muxum-selling-plan]:checked') : null;
      if (selectedSubInput && selectedSubInput.value) {
        var planPriceEl = pdp.querySelector('[data-muxum-plan-price="' + selectedSubInput.value + '"]');
        if (planPriceEl && planPriceEl.textContent.trim()) {
          return planPriceEl.textContent.trim();
        }
      }
      var selectedVariantInput = pdp.querySelector('input[data-muxum-variant-id]:checked, input[type=hidden][data-muxum-variant-id]');
      if (selectedVariantInput) {
        var price = parseInt(selectedVariantInput.dataset.variantPrice, 10);
        if (!isNaN(price)) return selectedVariantInput.dataset.variantPriceFmt || moneyFmt(price);
      }
      if (priceNow) return priceNow.textContent.trim();
      return '';
    }

    function updateSubmitPrice() {
      if (submitPrice) submitPrice.textContent = getCurrentPrice();
    }

    /* === Form submit (AJAX add to cart, opens drawer) === */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(form);
        submit.disabled = true;
        if (submitLabel) submitLabel.textContent = 'Añadiendo…';
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add to cart failed');
            return r.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('muxum:cart:updated'));
            document.dispatchEvent(new CustomEvent('muxum:cart:open'));
            if (submitLabel) {
              submitLabel.textContent = '¡Añadido!';
              setTimeout(function () {
                submit.disabled = false;
                if (submitLabel) submitLabel.innerHTML = 'Añadir — <span data-muxum-submit-price>' + getCurrentPrice() + '</span>';
              }, 900);
            } else {
              submit.disabled = false;
            }
          })
          .catch(function () {
            if (submitLabel) submitLabel.textContent = 'Error — intenta de nuevo';
            setTimeout(function () { submit.disabled = false; }, 1200);
          });
      });
    }

    /* === Thumbnail switcher === */
    pdp.querySelectorAll('[data-muxum-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setMainImage(thumb.dataset.img);
        pdp.querySelectorAll('[data-muxum-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    /* === Preload gallery + variant images (kills swap lag) === */
    var preloadSrcs = [];
    pdp.querySelectorAll('[data-muxum-thumb]').forEach(function (t) {
      if (t.dataset.img) preloadSrcs.push(t.dataset.img);
    });
    pdp.querySelectorAll('input[data-muxum-variant-id]').forEach(function (i) {
      if (i.dataset.variantImage) preloadSrcs.push(i.dataset.variantImage);
    });
    preloadSrcs.forEach(function (src) {
      var im = new Image();
      im.src = src;
    });

    /* === Zoom / lightbox on main image === */
    if (mainImg) {
      var lightbox = null;
      var closeLightbox = function () {
        if (lightbox) lightbox.classList.remove('is-open');
        document.removeEventListener('keydown', onKey);
      };
      var onKey = function (e) {
        if (e.key === 'Escape') closeLightbox();
      };
      mainImg.addEventListener('click', function () {
        var src = mainImg.dataset.fullSrc || mainImg.currentSrc || mainImg.src;
        if (!src) return;
        if (!lightbox) {
          lightbox = document.createElement('div');
          lightbox.className = 'mx-pdp__lightbox';
          lightbox.setAttribute('role', 'dialog');
          lightbox.setAttribute('aria-label', 'Imagen ampliada');
          lightbox.innerHTML = '<img alt="">';
          lightbox.addEventListener('click', closeLightbox);
          document.body.appendChild(lightbox);
        }
        lightbox.querySelector('img').src = src;
        lightbox.classList.add('is-open');
        document.addEventListener('keydown', onKey);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-muxum-pdp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
